import React, { useEffect, useRef } from 'react';
import AcceptInvitationForm from '../components/AcceptInvitationForm';
import { useAuth } from '../context/AuthContext';

export const AcceptInvitation = () => {
  const { user, logout } = useAuth();
  const hasCheckedInitialUser = useRef(false);

  useEffect(() => {
    // Only logout existing user on initial mount, not after successful login
    if (!hasCheckedInitialUser.current) {
      hasCheckedInitialUser.current = true;
      if (user) {
        logout();
      }
    }
  }, [user, logout]);

  return <AcceptInvitationForm />;
};
